import { render, staticRenderFns } from "./GetMarkdownFile.vue?vue&type=template&id=561e4369"
import script from "./GetMarkdownFile.vue?vue&type=script&lang=js"
export * from "./GetMarkdownFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports